import { AudioManager } from '../../core/AudioManager';
import { AudioHandle, PositionalOptions } from '../../core/AudioManager.types';
import { Car } from '../Car';

export class PoliceSirenAudio {
    static readonly PRELOAD = ['../assets/sounds/police_siren.wav'] as const;
    private static readonly SRC = PoliceSirenAudio.PRELOAD[0];
    private static readonly OPTIONS: PositionalOptions = { volume: 1, loop: true, refDistance: 5 };

    private handle: AudioHandle | null = null;

    constructor(
        private readonly audioManager: AudioManager,
        private readonly car: Car,
    ) {}

    public play(): void {
        if (this.handle) { return; }
        this.handle = this.audioManager.playPositional(PoliceSirenAudio.SRC, this.car, PoliceSirenAudio.OPTIONS);
    }

    public stop(): void {
        if (!this.handle) { return; }
        this.audioManager.stopPositional(this.handle);
        this.handle = null;
    }
}
